import { defineStore } from "pinia";
import axios from "axios";
import { SUBMISSION_ENDPOINTS } from "@/api/submission.endpoints.js";

export const useSubmissionBundlesStore = defineStore("submissionBundles", {
  state: () => ({
    bundles: [],
    phoneCases: [],
    drinkware: [],
    stickers: { bySize: [] },
    hatBundles: [],
    beanieBundles: [],
    toteBundles: [],
    isLoaded: false,
    isLoading: false,
  }),

  actions: {
    async load() {
      if (this.isLoaded || this.isLoading) return;
      this.isLoading = true;
      try {
        const { data } = await axios.get(SUBMISSION_ENDPOINTS.bundles);
        this.bundles = data.bundles;
        this.phoneCases = data.phoneCases;
        this.drinkware = data.drinkware;
        this.stickers = data.stickers;
        this.hatBundles = data.hatBundles;
        this.beanieBundles = data.beanieBundles;
        this.toteBundles = data.toteBundles;
        this.isLoaded = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
});
